import { of } from 'rxjs';

export const intersectionObserverServiceMock = {
    isScreenSmall$: of(false),
} as any;
